import React from 'react';
import {
    NavLink,
    Redirect,
    Route,
    Switch
} from 'react-router-dom';

import Nav from './../components/Nav';

//import HelpFaqPage from './HelpFaqPage';
import HelpGuidesPage from './HelpGuidesPage';

const HelpPage = ({ match }) => {
    return (
        <div>
            <Nav sub>
                {/* <NavLink to={`${match.url}/faq`}>FAQ</NavLink> */}
                <NavLink to={`${match.url}/guides`}>Guides</NavLink>
            </Nav>
            <Switch>
                {/* <Route path={`${match.url}/faq`} component={HelpFaqPage} /> */}
                <Route path={`${match.url}/guides`} component={HelpGuidesPage} />
                <Redirect from={match.url} exact to={{ pathname: `${match.url}/guides`, search: window.location.search }} push={false} />
            </Switch>
        </div>
    );
};

export default HelpPage;


// WEBPACK FOOTER //
// ./src/pages/HelpPage.js